import React, { useState, useEffect, useCallback } from "react";
import Slider from "react-slick";
import { SVGIcons, ImgIcons, Imgbanner } from "../../Helpers/Common";
import { Link } from "react-router-dom";
import { LiveTVplayer } from "../../components/vidjs/mainPlayer";

var SVGIcon = "";
SVGIcons().then((resultData) => (SVGIcon = resultData));
var ImageData = "";
ImgIcons().then((result) => (ImageData = result));

export function Layout15(props) {
  const [player, setPlayer] = useState(false);
  const [playerbtn, setPlayerbtn] = useState(false);
  // const [showShimmer, setShowShimmer] = useState(true);

  // const handleTimeout = useCallback(() => {
  //   setShowShimmer(false);
  // }, []);

  // useEffect(() => {
  //   // const timer = setTimeout(() => {
  //   setShowShimmer(false);
  //   // }, 1000);

  //   // return () => {
  //   //   clearTimeout(timer);
  //   // };
  // }, [handleTimeout]);

  function playlivetv() {
    setPlayer(true);
    setPlayerbtn(true);
  }

  let clsebtn = () => {
    // setPlayer(false)
    var element = document.getElementById("LiveTVplayer");
    setPlayer(false);
  };

  return (
    <>
      {player ? (
        <div id="LiveTVplayer">
          <LiveTVplayer
            data={props.title.contents[0].live_app_url}
            post={props.title.contents[0].thumbnail_image2}
            content={props}
            autoplay={true}
            loader={true}
            functionclose={clsebtn}
          />
        </div>
      ) : null}
      {props.title.contents ? (
        <section className="mb-0">
          <div className="temp24">
            <div className="temp24-inner">
              {/* {showShimmer ? (
                <div className="LiveLayout">
                  <img src={ImageData["placeholder3.png"]} alt="shimmer" className="shimmer" />
                  <div className="LineSkeleton">
                    <div className="line" />
                    <div className="line" />
                    <div className="line" />
                    <div className="line" />
                    <div className="line" />
                    <div className="line" />
                  </div>
                  <div className="lineBtn dD-block" />
                </div>
              ) : ( */}
              <>
                <div className="temp24-left">
                  <img
                    src={props.Layout1[0].thumbnail_image1?.small}
                    alt="DocuBay"
                  />
                </div>
                <div className="temp24-right">
                  <div>
                    <div className="live">
                      <span className="dot" />
                      {props.title.display_title}
                    </div>
                    <div className="now-showing">
                      <h4>NOW SHOWING</h4> :&emsp;{" "}
                      <marquee>{props.Layout1[0].title}</marquee>
                    </div>
                  </div>
                  <Link to={"/playlive"}>
                    <button
                      type="submit"
                      id="sendEnquiryBtn"
                      className="watch-nowBtn dD-none"
                    >
                      WATCH NOW
                    </button>
                  </Link>
                </div>
                <Link to={"/playlive"}>
                  <button
                    type="submit"
                    id="sendEnquiryBtn"
                    className="watch-nowBtn1 dD-block"
                  >
                    WATCH NOW
                  </button>
                </Link>
              </>
              {/* )} */}
            </div>
          </div>
        </section>
      ) : null}
    </>
  );
}

export default Layout15;
